import React from "react";
import ReactToPrint from "react-to-print";
import { NumericFormat } from 'react-number-format';
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import { useRef } from "react";

export const ComponentToPrint = React.forwardRef((props, ref) => {
  const datosFactura = props.datosFactura

  //console.log('datosFactura?.datosPago?', datosFactura?.datosPago)

  return (
    <div className="cont_tiket" ref={ref}>
      <h4>Blue Moon Beauty SD INC</h4>
      <span>Principal</span><br />
      <span>https://bluemoonbeautysd.com</span><br />
      <hr className="lineaFactura" />

      <span>Factura: {datosFactura.codigo}</span><br />
      <span>Vendedor: {datosFactura.datosPago.vendedor}</span><br />
      <span>Fecha y hora: {datosFactura.fecha}</span><br />
      <hr className="lineaFactura" />

      <div className="combina_tiquete" style={{ textAlign: 'left' }}>
        <span>Cliente: {datosFactura.cliente.nombre}</span><br />
        <span>Teléfono: {datosFactura.cliente.tel}</span><br />
        <span>Dirección: {datosFactura.cliente.direccion}</span><br />
        <span>Email: {datosFactura.cliente.email}</span><br />
      </div>
      <hr className="lineaFactura" />

      <span>DETALLE DEL PEDIDO:</span><br />

      <div>
        <MDBTable responsive>
          <MDBTableBody>
            <tr className="tabla_tiquete">
              <td></td>
              <td>Productos:</td>
              <td>V. Unitario:</td>
              <td>Total:</td>
            </tr>
            {datosFactura.pedido.map((item, index) => (
              <tr className="tabla_tiquete" key={index}>
                <td>{item.cantidad_producto}</td>
                <td>{item.nombre_producto}</td>
                <td><NumericFormat value={item.precio_rebajado > 0 ? item.precio_rebajado : item.precio_producto} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
                <td><NumericFormat value={item.precio_rebajado > 0 ? item.precio_rebajado * item.cantidad_producto : item.precio_producto * item.cantidad_producto} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
              </tr>
            ))}
            <tr className="tabla_tiquete">
              <td></td>
              <td></td>
              <td style={{ borderTop: '2px solid #000' }}>SUBTOTAL:</td>
              <td><NumericFormat decimalScale={2} value={parseFloat(datosFactura.datosPago.subtotal) + parseFloat(datosFactura.datosPago.descuento)} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
            </tr>
          </MDBTableBody>
        </MDBTable>
      </div>

      {/* <span>SUBTOTAL: <NumericFormat decimalScale={2} value={parseFloat(datosFactura.datosPago.subtotal)} displayType={'text'} thousandSeparator={true} prefix={'$'} /> </span><br /> */}
      <hr className="lineaFactura" />

      <span>DATOS DE PAGO:</span><br />
      <MDBTable responsive>
        <MDBTableBody>
          {datosFactura.datosPago.medio !== 'Efectivo' && (
            <tr className="tabla_tiquete">
              <td>NOMBRE IMPUESTO:</td>
              <td><span><NumericFormat decimalScale={2} value={datosFactura.datosPago.impuesto_nombre} displayType={'text'} thousandSeparator={true} prefix={'$'} /> </span> <br /></td>
            </tr>
          )}

          <tr className="tabla_tiquete">
            <td>SUBTOTAL:</td>
            <td><span><NumericFormat decimalScale={2} value={parseFloat(datosFactura.datosPago.subtotal) + parseFloat(datosFactura.datosPago.descuento)} displayType={'text'} thousandSeparator={true} prefix={'$'} /> </span> <br /></td>
          </tr>
          <tr className="tabla_tiquete">
            <td>DESCUENTO:</td>
            <td><span><NumericFormat decimalScale={2} value={datosFactura.datosPago.descuento} displayType={'text'} thousandSeparator={true} prefix={'$'} /> </span> <br /></td>
          </tr>
          <tr className="tabla_tiquete">
            <td>TAX:</td>
            <td><span><NumericFormat decimalScale={2} value={datosFactura.datosPago.valor_impuesto} displayType={'text'} thousandSeparator={true} prefix={'$'} /> </span> <br /></td>
          </tr>
          <tr className="tabla_tiquete">
            <td>FEE:</td>
            <td><span><NumericFormat decimalScale={2} value={datosFactura.datosPago.fee} displayType={'text'} thousandSeparator={true} prefix={'$'} /> </span> <br /></td>
          </tr>
          <tr className="tabla_tiquete">
            <td>IMPORTE RECIBIDO:</td>
            <td><span><NumericFormat decimalScale={2} value={datosFactura.datosPago.importe} displayType={'text'} thousandSeparator={true} prefix={'$'} /> </span> <br /></td>
          </tr>
          <tr className="tabla_tiquete">
            <td>CAMBIO:</td>
            <td><span><NumericFormat decimalScale={2} value={datosFactura.datosPago.cambio} displayType={'text'} thousandSeparator={true} prefix={'$'} /> </span> <br /></td>
          </tr>
          <tr className="tabla_tiquete">
            <td>TOTAL:</td>
            <td><span><NumericFormat decimalScale={2} value={datosFactura.datosPago.total} displayType={'text'} thousandSeparator={true} prefix={'$'} /> </span> <br /></td>
          </tr>

        </MDBTableBody>
      </MDBTable>
      <hr className="lineaFactura" />



      {datosFactura?.datosPago?.mediosPagoPasarela?.length > 0 ?
        <div>
          <span>MEDIOS DE PAGO:</span><br />

          <MDBTable responsive>
            <MDBTableBody>
              <tr className="tabla_tiquete">
                <td>MEDIO:</td>
                <td>TAX:</td>
                <td>FEE:</td>
                <td>TOTAL:</td>
              </tr>
              {datosFactura?.datosPago?.mediosPagoPasarela.map(item =>

                item.importe + item.interes > 0 ?

                  item.medioPagoNombre === 'Efectivo' ?
                    (
                      <tr className="tabla_tiquete">
                        <td>{item.medioPagoNombre}</td>
                        <td><NumericFormat value={item.interes} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} /></td>
                        <td><NumericFormat value={item.tarifaPorcentaje} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} /> </td>
                        <td><NumericFormat value={(item.importe + item.interes + item.tarifaPorcentaje) - datosFactura.datosPago.cambio} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} /> </td>
                      </tr>
                    )
                    :
                    (
                      <tr className="tabla_tiquete">
                        <td>{item.medioPagoNombre}</td>
                        <td><NumericFormat value={item.interes} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} /></td>
                        <td><NumericFormat value={item.tarifaPorcentaje} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} /> </td>
                        <td><NumericFormat value={(item.importe + item.interes + item.tarifaPorcentaje)} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} /> </td>
                      </tr>
                    )
                  : null
              )}
            </MDBTableBody>
          </MDBTable>
        </div>
        :

        <div>
          <span>DATOS DE PAGO:</span><br />
          <div className="combina_tiquete" style={{ textAlign: 'left' }}>
            <span>MEDIO: {datosFactura.datosPago.medio}</span><br />
            {datosFactura.datosPago.medio !== 'Efectivo' && (<>  <span>REFERENCIA: {datosFactura.datosPago.referencia}</span><br /></>)}
            <span>RECIBIDO: <NumericFormat value={datosFactura.datosPago.importe} displayType={'text'} thousandSeparator={true} prefix={'$'} /></span><br />
            <span>CAMBIO: <NumericFormat decimalScale={2} value={datosFactura.datosPago.importe - datosFactura.datosPago.total} displayType={'text'} thousandSeparator={true} prefix={'$'} /></span><br />
          </div>
        </div>

      }

      <hr className="lineaFactura" />
      <span>TOTAL A PAGAR: </span>
      <NumericFormat decimalScale={2} value={datosFactura.datosPago.total} displayType={'text'} thousandSeparator={true} prefix={'$'} />
      <br />



      <hr className="lineaFactura" />
      <span>Impreso por:</span><br />
      <span>Tecnosoluciones y Software</span><br />
      <span>www.tecnosolagencia.com - (+57) 315 415 5690</span><br />
      <hr className="lineaFactura" />
      <span>No se hacen devoluciones ni cambios de productos</span><br />
      <br />
      <span></span><br /><span></span><br />

    </div>
  );
});

const Tiquete = ({ datosFactura, selectDomi }) => {
  const componentRef = useRef();
  return (
    <div>
      <center>
        <ReactToPrint
          trigger={() =>
            <a href="#"
              className="btn boton_estandar"
            >Imprimir Ticket
            </a>}
          content={() => componentRef.current}
        />

      </center>
      <ComponentToPrint
        key={'111a'}
        ref={componentRef}
        datosFactura={datosFactura}
        selectDomi={selectDomi} />
    </div>
  );
}

export default Tiquete;